import { z } from "zod";

export interface SensorHealthSummary {
  total: number;
  online: number;
  inconsistent: number;
  offline: number;
  unlinked: number;
  oldestReadingAt: string | null;
}

export const CreateLineRequestSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  responsible: z.string().max(120).optional(),
  // Spec 081 (FR-019) — a unidade em que a linha declara o que produz. Obrigatória na criação, sem
  // padrão automático: a escolha é do gestor. Trocá-la depois NÃO reconverte nada — os lançamentos
  // gravados mantêm o valor que tinham e a mudança vale daí para frente (FR-022, FR-023).
  productionUnit: z.string().min(1).max(20),
});
export type CreateLineRequest = z.infer<typeof CreateLineRequestSchema>;

export const UpdateLineRequestSchema = CreateLineRequestSchema.partial();
export type UpdateLineRequest = z.infer<typeof UpdateLineRequestSchema>;

export const LineStatusFilterSchema = z.enum(["RUNNING", "STOPPED", "PARTIAL", "IDLE"]).optional();
export const ReliabilityFilterSchema = z.enum(["HIGH", "MEDIUM", "LOW"]).optional();

export const ListLinesQuerySchema = z.object({
  status: LineStatusFilterSchema,
  reliability: ReliabilityFilterSchema,
});

export const ConnectionsRequestSchema = z.object({
  connections: z
    .array(
      z.object({
        fromMachineId: z.string().uuid(),
        toMachineId: z.string().uuid(),
      })
    )
    .max(500),
});
export type ConnectionsRequest = z.infer<typeof ConnectionsRequestSchema>;
